/** RTE-X11.5c — multi-edge allocation editor (default OFF). */

let multiEdgeFlagLogged = false;

export function isMultiEdgeAllocationEditorEnabled(): boolean {
  const raw = process.env.REACT_APP_MULTI_EDGE_ALLOCATION_EDITOR;
  const enabled = String(raw || '').toLowerCase() === 'true';
  if (process.env.NODE_ENV === 'development' && !multiEdgeFlagLogged) {
    multiEdgeFlagLogged = true;
    // eslint-disable-next-line no-console
    console.log(
      '[RTE-X11.5c] REACT_APP_MULTI_EDGE_ALLOCATION_EDITOR raw =',
      raw,
      '| parsed =',
      enabled
    );
  }
  return enabled;
}
